import React from "react";
import { Button, Box } from "@mui/material";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  button: {
    marginBottom: theme.spacing(2),
    width: "100%",
    textTransform: "none"
  }
}));

export default function SlideOutActions(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Box
        pb={1}
        mx="auto"
        minWidth={202}
        display="flex"
        flexDirection="column"
        alignSelf="center"
      >
        {props.actions &&
          props.actions.map((button, index) => (
            <NavLink to={button.path} key={index}>
              <Button
                variant={button.variant}
                color="primary"
                className={classes.button}
                onClick={() => props.handleSlideOutClose()}
              >
                {button.text}
              </Button>
            </NavLink>
          ))}
      </Box>
    </React.Fragment>
  );
}

SlideOutActions.propTypes = {
  header: PropTypes.string,
  content: PropTypes.string
};
